import { Box, styled } from "@mui/material";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

const Root = styled(Box)({
  padding: "12px",
});

export default function Copyright(props) {
  return (
    <Root>
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {"Copyright © "}
        <Link color="inherit" href="https://floats.ai/">
          floats.ai
        </Link>{" "}
        {new Date().getFullYear()}
        {"."}
      </Typography>
    </Root>
  );
}
